// import React, { useState, useEffect } from "react";
// import "./layout.css";
// import {
//   FiMenu,
//   FiGrid,
//   FiShoppingBag,
//   FiShoppingCart,
//   FiUsers,
//   FiChevronDown,
//   FiChevronUp,
//   FiSearch,
//   FiBell,
//   FiSettings,
//   FiUser,
//   FiLogOut,
//   FiTool, // Added for Operations icon
// } from "react-icons/fi";
// import { useNavigate, useLocation } from "react-router-dom";
// import logo from "../../assets/image.png";

// const API_BASE_URL = process.env.REACT_APP_EP || "http://localhost:5000";

// // Map current URL path to the corresponding menu key
// const getMenuKeyFromPath = (pathname) => {
//   if (pathname === "/" || pathname === "/dashboard") return "dashboard";
//   if (pathname.startsWith("/products")) return "product-list";
//   if (pathname.startsWith("/categories")) return "categories";
//   if (pathname.startsWith("/orders")) return "orders";
//   if (pathname.startsWith("/customers")) return "customers";
//   if (pathname.startsWith("/operations")) return "operations"; // Added operations
//   return "dashboard";
// };

// // Check if a path belongs to Product submenu
// const isProductSubPath = (pathname) => {
//   return pathname.startsWith("/products") || pathname.startsWith("/categories");
// };

// const Layout = ({ children }) => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   // NEW: store logged-in user's name
//   const [userName, setUserName] = useState("");

//   // Initialize submenu open state based on current path
//   const [isProductOpen, setIsProductOpen] = useState(() =>
//     isProductSubPath(location.pathname)
//   );

//   // Initialize activeItem from current path
//   const [activeItem, setActiveItem] = useState(() =>
//     getMenuKeyFromPath(location.pathname)
//   );

//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const [isProfileOpen, setIsProfileOpen] = useState(false);

//   // Keep activeItem AND submenu state in sync with route changes
//   useEffect(() => {
//     const currentKey = getMenuKeyFromPath(location.pathname);
//     setActiveItem(currentKey);

//     // Auto-expand Product submenu if on a product-related page
//     if (isProductSubPath(location.pathname)) {
//       setIsProductOpen(true);
//     }
//   }, [location.pathname]);

//     useEffect(() => {
//     const storedName = localStorage.getItem("userName");
//     if (storedName) {
//       setUserName(storedName);
//     }
//   }, []);

//   // Sidebar responsive behavior / cleanup
//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth > 768) {
//         setIsSidebarOpen(false);
//         document.body.classList.remove("sidebar-open");
//       }
//     };

//     window.addEventListener("resize", handleResize);

//     return () => {
//       window.removeEventListener("resize", handleResize);
//       document.body.classList.remove("sidebar-open");
//     };
//   }, []);

//   const handleMenuClick = (key) => {
//     setActiveItem(key);
//     closeSidebar();
//     console.log(`Menu clicked: ${key}`);
//   };

//   const closeSidebar = () => {
//     setIsSidebarOpen(false);
//     document.body.classList.remove("sidebar-open");
//   };

//   const toggleSidebar = () => {
//     setIsSidebarOpen((prev) => {
//       const next = !prev;
//       if (next) {
//         document.body.classList.add("sidebar-open");
//       } else {
//         document.body.classList.remove("sidebar-open");
//       }
//       return next;
//     });
//   };

//   const handleProfileBlur = (e) => {
//     if (!e.currentTarget.contains(e.relatedTarget)) {
//       setIsProfileOpen(false);
//     }
//   };

//   const handleLogout = async () => {
//   try {
//     await fetch(`${API_BASE_URL}/api/auth/logout`, {
//       method: "POST",
//       credentials: "include",
//     });
//   } catch (error) {
//     console.error("Logout error:", error);
//   } finally {
//     sessionStorage.clear();
//     localStorage.removeItem("isLoggedIn");
//     localStorage.removeItem("userName"); // <-- clear name

//     setIsProfileOpen(false);
//     navigate("/signin", { replace: true });
//   }
// };

//   return (
//     <div className="app-layout">
//       {/* LEFT SIDEBAR */}
//       <aside className="sidebar">
//         <div className="sidebar-logo">
//           <img
//             src={logo}
//             alt="Shubha Graphics"
//             className="header__logo"
//           />
//         </div>

//         <nav className="sidebar-nav">
//           {/* Dashboard */}
//           <button
//             className={`sidebar-item ${activeItem === "dashboard" ? "active" : ""}`}
//             onClick={() => {
//               handleMenuClick("dashboard");
//               navigate("/");
//             }}
//           >
//             <FiGrid className="sidebar-icon" />
//             <span>Dashboard</span>
//           </button>

//           {/* Product Submenu */}
//           <div className="sidebar-group">
//             <button
//               className={`sidebar-item sidebar-item-parent ${
//                 ["product-list", "categories"].includes(activeItem)
//                   ? "active-parent"
//                   : ""
//               }`}
//               onClick={() => setIsProductOpen((prev) => !prev)}
//             >
//               <div className="sidebar-parent-main">
//                 <FiShoppingBag className="sidebar-icon" />
//                 <span>Product</span>
//               </div>
//               {isProductOpen ? (
//                 <FiChevronUp className="sidebar-chevron" />
//               ) : (
//                 <FiChevronDown className="sidebar-chevron" />
//               )}
//             </button>

//             {isProductOpen && (
//               <div className="sidebar-submenu">
//                 <button
//                   className={`sidebar-subitem ${
//                     activeItem === "product-list" ? "active" : ""
//                   }`}
//                   onClick={() => {
//                     handleMenuClick("product-list");
//                     navigate("/products");
//                   }}
//                 >
//                   <span>Product List</span>
//                 </button>
//                 <button
//                   className={`sidebar-subitem ${
//                     activeItem === "categories" ? "active" : ""
//                   }`}
//                   onClick={() => {
//                     handleMenuClick("categories");
//                     navigate("/categories");
//                   }}
//                 >
//                   <span>Categories</span>
//                 </button>
//               </div>
//             )}
//           </div>

//           {/* Orders */}
//           <button
//             className={`sidebar-item ${activeItem === "orders" ? "active" : ""}`}
//             onClick={() => {
//               handleMenuClick("orders");
//               navigate("/orders");
//             }}
//           >
//             <FiShoppingCart className="sidebar-icon" />
//             <span>Orders</span>
//           </button>

//           {/* Customers */}
//           <button
//             className={`sidebar-item ${activeItem === "customers" ? "active" : ""}`}
//             onClick={() => {
//               handleMenuClick("customers");
//               navigate("/customers");
//             }}
//           >
//             <FiUsers className="sidebar-icon" />
//             <span>Panchayat</span>
//           </button>

//           {/* Operations - NEW */}
//           <button
//             className={`sidebar-item ${activeItem === "operations" ? "active" : ""}`}
//             onClick={() => {
//               handleMenuClick("operations");
//               navigate("/operations");
//             }}
//           >
//             <FiTool className="sidebar-icon" />
//             <span>Operations</span>
//           </button>
//         </nav>
//       </aside>

//       {/* RIGHT SIDE (HEADER + WORKSPACE) */}
//       <div className="main-area">
//         {/* HEADER BAR */}
//         <header className="header">
//           <div className="header-left">
//             {/* Mobile menu toggle button (hidden on desktop via CSS) */}
//             <button
//               type="button"
//               className="icon-button mobile-menu-toggle"
//               onClick={toggleSidebar}
//               aria-label="Toggle navigation menu"
//             >
//               <FiMenu />
//             </button>
//           </div>

//           <div className="header-right">
//             {/* PROFILE SECTION */}
//             <div className="profile" tabIndex="0" onBlur={handleProfileBlur}>
//               <div className="profile-avatar">
//                 <div className="avatar-circle">
//                   <FiUser />
//                 </div>
//                 <span className="status-dot online" />
//               </div>

//               <div className="profile-text">
//                 <span className="profile-name">{userName || "Shubha Graphics"}</span>
//                 <span className="profile-role">Manager</span>
//               </div>

//               <button
//                 className="profile-dropdown-toggle"
//                 onClick={() => setIsProfileOpen((prev) => !prev)}
//               >
//                 <FiChevronDown />
//               </button>

//               {isProfileOpen && (
//                 <div className="profile-menu">
//                   <button onClick={() => console.log("View profile")}>
//                     View Profile
//                   </button>
//                   <button onClick={() => console.log("Account settings")}>
//                     Account Settings
//                   </button>
//                   <button onClick={() => console.log("Help & support")}>
//                     Help &amp; Support
//                   </button>
//                   <button onClick={handleLogout}>
//                     <FiLogOut className="profile-menu-icon" />
//                     <span>Logout</span>
//                   </button>
//                 </div>
//               )}
//             </div>
//           </div>
//         </header>

//         {/* WORKSPACE */}
//         <main className="workspace">{children}</main>
//       </div>
//     </div>
//   );
// };

// export default Layout;

import React, { useState, useEffect } from "react";
import "./layout.css";
import {
  FiMenu,
  FiGrid,
  FiShoppingBag,
  FiShoppingCart,
  FiUsers,
  FiChevronDown,
  FiChevronUp,
  FiUser,
  FiLogOut,
  FiTool,
  FiTrendingUp, 
} from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../../assets/image.png";

const API_BASE_URL = process.env.REACT_APP_EP || "http://localhost:5000";

const getMenuKeyFromPath = (pathname) => {
  if (pathname === "/" || pathname === "/dashboard") return "dashboard";
  if (pathname.startsWith("/products")) return "product-list";
  if (pathname.startsWith("/categories")) return "categories";
  if (pathname.startsWith("/orders")) return "orders";
  if (pathname.startsWith("/customers")) return "customers";
  if (pathname.startsWith("/operations")) return "operations";
  if (pathname.startsWith("/marketing")) return "marketing"; 
  return "dashboard";
};

const isProductSubPath = (pathname) => {
  return pathname.startsWith("/products") || pathname.startsWith("/categories");
};

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [userName, setUserName] = useState("");

  const [isProductOpen, setIsProductOpen] = useState(() =>
    isProductSubPath(location.pathname)
  );

  const [activeItem, setActiveItem] = useState(() =>
    getMenuKeyFromPath(location.pathname)
  );

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);

  useEffect(() => {
    const currentKey = getMenuKeyFromPath(location.pathname);
    setActiveItem(currentKey);

    if (isProductSubPath(location.pathname)) {
      setIsProductOpen(true);
    }
  }, [location.pathname]);

  useEffect(() => {
    const storedName = localStorage.getItem("userName");
    if (storedName) {
      setUserName(storedName);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsSidebarOpen(false);
        document.body.classList.remove("sidebar-open");
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      document.body.classList.remove("sidebar-open");
    };
  }, []);

  const handleMenuClick = (key) => {
    setActiveItem(key);
    closeSidebar();
    console.log(`Menu clicked: ${key}`);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
    document.body.classList.remove("sidebar-open");
  };

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => {
      const next = !prev;
      if (next) {
        document.body.classList.add("sidebar-open");
      } else {
        document.body.classList.remove("sidebar-open");
      }
      return next;
    });
  };

  const handleProfileBlur = (e) => {
    if (!e.currentTarget.contains(e.relatedTarget)) {
      setIsProfileOpen(false);
    }
  };

  const handleLogout = async () => {
    try {
      await fetch(`${API_BASE_URL}/api/auth/logout`, {
        method: "POST",
        credentials: "include",
      });
    } catch (error) {
      console.error("Logout error:", error);
    } finally {
      sessionStorage.clear();
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("userName");

      setIsProfileOpen(false);
      navigate("/signin", { replace: true });
    }
  };

  return (
    <div className="app-layout">
      {/* LEFT SIDEBAR */}
      <aside className="sidebar">
        <div className="sidebar-logo">
          <img
            src={logo}
            alt="Shubha Graphics"
            className="header__logo"
          />
        </div>

        <nav className="sidebar-nav">
          {/* Dashboard */}
          <button
            className={`sidebar-item ${activeItem === "dashboard" ? "active" : ""}`}
            onClick={() => {
              handleMenuClick("dashboard");
              navigate("/");
            }}
          >
            <FiGrid className="sidebar-icon" />
            <span>Dashboard</span>
          </button>

          {/* Product Submenu */}
          <div className="sidebar-group">
            <button
              className={`sidebar-item sidebar-item-parent ${
                ["product-list", "categories"].includes(activeItem)
                  ? "active-parent"
                  : ""
              }`}
              onClick={() => setIsProductOpen((prev) => !prev)}
            >
              <div className="sidebar-parent-main">
                <FiShoppingBag className="sidebar-icon" />
                <span>Product</span>
              </div>
              {isProductOpen ? (
                <FiChevronUp className="sidebar-chevron" />
              ) : (
                <FiChevronDown className="sidebar-chevron" />
              )}
            </button>

            {isProductOpen && (
              <div className="sidebar-submenu">
                <button
                  className={`sidebar-subitem ${
                    activeItem === "product-list" ? "active" : ""
                  }`}
                  onClick={() => {
                    handleMenuClick("product-list");
                    navigate("/products");
                  }}
                >
                  <span>Product List</span>
                </button>
                <button
                  className={`sidebar-subitem ${
                    activeItem === "categories" ? "active" : ""
                  }`}
                  onClick={() => {
                    handleMenuClick("categories");
                    navigate("/categories");
                  }}
                >
                  <span>Categories</span>
                </button>
              </div>
            )}
          </div>

          {/* Orders */}
          <button
            className={`sidebar-item ${activeItem === "orders" ? "active" : ""}`}
            onClick={() => {
              handleMenuClick("orders");
              navigate("/orders");
            }}
          >
            <FiShoppingCart className="sidebar-icon" />
            <span>Orders</span>
          </button>

          {/* Customers */}
          <button
            className={`sidebar-item ${activeItem === "customers" ? "active" : ""}`}
            onClick={() => {
              handleMenuClick("customers");
              navigate("/customers");
            }}
          >
            <FiUsers className="sidebar-icon" />
            <span>Panchayat</span>
          </button>

          {/* Operations */}
          <button
            className={`sidebar-item ${activeItem === "operations" ? "active" : ""}`}
            onClick={() => {
              handleMenuClick("operations");
              navigate("/operations");
            }}
          >
            <FiTool className="sidebar-icon" />
            <span>Operations</span>
          </button>

          {/* Marketing - NEW */}
          <button
            className={`sidebar-item ${activeItem === "marketing" ? "active" : ""}`}
            onClick={() => {
              handleMenuClick("marketing");
              navigate("/marketing");
            }}
          >
            <FiTrendingUp className="sidebar-icon" />
            <span>Marketing</span>
          </button>
        </nav>
      </aside>

      {/* RIGHT SIDE (HEADER + WORKSPACE) */}
      <div className="main-area">
        {/* HEADER BAR */}
        <header className="header">
          <div className="header-left">
            <button
              type="button"
              className="icon-button mobile-menu-toggle"
              onClick={toggleSidebar}
              aria-label="Toggle navigation menu"
            >
              <FiMenu />
            </button>
          </div>

          <div className="header-right">
            {/* PROFILE SECTION */}
            <div className="profile" tabIndex="0" onBlur={handleProfileBlur}>
              <div className="profile-avatar">
                <div className="avatar-circle">
                  <FiUser />
                </div>
                <span className="status-dot online" />
              </div>

              <div className="profile-text">
                <span className="profile-name">{userName || "Shubha Graphics"}</span>
                <span className="profile-role">Manager</span>
              </div>

              <button
                className="profile-dropdown-toggle"
                onClick={() => setIsProfileOpen((prev) => !prev)}
              >
                <FiChevronDown />
              </button>

              {isProfileOpen && (
                <div className="profile-menu">
                  <button onClick={() => console.log("View profile")}>
                    View Profile
                  </button>
                  <button onClick={() => console.log("Account settings")}>
                    Account Settings
                  </button>
                  <button onClick={() => console.log("Help & support")}>
                    Help &amp; Support
                  </button>
                  <button onClick={handleLogout}>
                    <FiLogOut className="profile-menu-icon" />
                    <span>Logout</span>
                  </button>
                </div>
              )}
            </div>
          </div>
        </header>

        {/* WORKSPACE */}
        <main className="workspace">{children}</main>
      </div>
    </div>
  );
};

export default Layout;